import React, { Component } from 'react';
import { BarGraphWithLabel , LegendComp } from '../../../common/graph/bar-graph.component';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';
import '../report-page.component.css';

const graphData = [
    { name: "APAC", dfive: 13, dsixtofifteen: 13, dgreaterfifteen:0},
    { name: "WE", dfive: 0, dsixtofifteen: 12, dgreaterfifteen:0},
    { name: "SEE", dfive: 6, dsixtofifteen: 18, dgreaterfifteen:12},
    { name: "NE", dfive: 14, dsixtofifteen: 0, dgreaterfifteen:0},
    { name: "LAT", dfive: 12, dsixtofifteen: 12, dgreaterfifteen:14}
  ];


const countData = [ { total: '2', description:'Total Count <5 Days'},
                    { total: '1', description:'Total Count 6-15 Days'},
                    { total: '321', description:'Total Count >15 Days'}
                ];

const  barData = [ 
            {dataKey: 'dfive', name: '5 days', color:'#ffc82c'}, 
            {dataKey: 'dsixtofifteen', name: '6-15 days', color:'#7ec344'}, 
            {dataKey: 'dgreaterfifteen', name: '>15 days', color:'#919eab'}
    ];

class TemReqComp extends Component {

    
    render() {        
        return (
            <div className="component-container legend-center">
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} ledger={barData} headerName="Ageing Progress Per Region" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false} totalCount={true}  countData={countData}  />
                <BarGraphWithLabel data={graphData} barData={barData} displayLegend={true} legendData={barData}/>  
                <LegendComp data={barData} />                  
            </div>
        )
    }

}

export default TemReqComp;